import React, { useEffect, useState } from 'react'
import { MODULES } from '../../../../core/data/constants/moduleConstants';
import { useStages } from '../../../crmSetting/stages/hooks/useStages';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { getAllUrlParams } from '../../../../utils/helpers/setAndGetUrlParams';
import { generateQueryParams } from '../../../../utils/helpers/generateQueryParams';
import { EDITED_SUCCESS_MSG, ERROR_MSG } from '../../../../core/data/constants/constant';
import { all_routes } from "../../../router/all_routes";
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { useCachedDealData } from '../hooks/getCachedDealData';
import DealApi from '../api/DealApi';
import { updateDealsListCache, updateSingleDealCache } from '../actions/updateDealsListCache';
import DealConfirmModal from './DealConfirmModal';
import DealDetailsSidebar from './DealDetailsSidebar';
// import SetReminderModal from '../../reminders/components/SetReminderModal';

export default function PostCallModal({isOpen,openModal,closeModal,dealData,dealId}) {
  console.log("dealData", dealData,dealId);
    const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
    const initialForceReload = searchParams.get("shouldRefetch") === "true";

  const [forceReload, setForceReload] = useState(false);
   
       const data = useCachedDealData(
          dealId,
          null
        );
      dealData = dealData?._id ?dealData : data?.dealData;
  
    
    const route = all_routes;
    const [remarkHistory, setRemarkHistory] = useState(dealData?.callHistoryRemarks || []);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedStage, setSelectedStage] = useState({});
    const [newRemark, setNewRemark] = useState('');
    const [pendingStageChange, setPendingStageChange] = useState(null);
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const urlParams = getAllUrlParams();
    const dispatch = useDispatch();
    
    // Get current user info from Redux state or context
    const { user } = useSelector((state) => state.auth || state.user);
    
    const { stagesData, isLoading } = useStages({
      ofCompany: dealData?.ofCompany?._id,
      module: MODULES.DEALS,
    });
    const stages = stagesData?.data?.data;
    const { filters } = useSelector((state) => state.filter);
     const dealsFilters = filters.deals || [];
    let { queryParams, params } = generateQueryParams(dealsFilters);
    const { currentStatus: currentStage } = dealData || {};

    // Format date-time for display
    const formatDateTime = (dateTime) => {
      const date = new Date(dateTime);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    };

    const mutationUpdate = useMutation({
        mutationFn: ({ id, updatedStage, callHistoryRemarks }) => {
          let updateData={};
          if (updatedStage) {
            updateData= {
            currentStatus: updatedStage,
            textMessageAboutActivity: `<b>${MODULES.LEADS.slice(
              0,
              -1
            )} currentStatus</b> updated from <b>${currentStage?.name}</b> to <b>${
              updatedStage?.name
            }</b>`,
          };
        }

        

          // Add call history remarks if provided
          if (callHistoryRemarks) {
            updateData.callHistoryRemarks = callHistoryRemarks;
          }

          return DealApi.updateDeal(id, updateData);
        },
        onMutate: async ({ id, updatedStage, callHistoryRemarks }) => {
          await queryClient.cancelQueries(["deal", id]);
    
          const previousDeal = queryClient.getQueryData(["deal", id]);
    
          const updateddealData = {
            ...previousDeal,
            currentStatus: updatedStage,
            ...(callHistoryRemarks && { callHistoryRemarks })
          };

          updateSingleDealCache(dealData?._id, updateddealData);
          
          updateDealsListCache({
            id: dealData?._id,
            updatedData: updateddealData,
            page: urlParams?.page * 1,
            limit: urlParams?.limit * 1,
            queryString: params?.toString(),
            queryParams: queryParams?.toString(),
            companyId: urlParams?.companyid,
          });
    
          return { previousDeal };
        },
        onSuccess: (response) => {
            console.log("response?.data", response?.data);
          if (response?.status) {
            toast.success(EDITED_SUCCESS_MSG);
            
            updateSingleDealCache(dealData?._id, response?.data);
    
            updateDealsListCache({
              id: dealData?._id,
              updatedData: response?.data,
              page: urlParams?.page * 1,
              limit: urlParams?.limit * 1,
              queryString: params?.toString(),
              queryParams: queryParams?.toString(),
              companyId: urlParams?.companyid,
            });

          
          }
    
        

        
          setNewRemark('');
          setPendingStageChange(null);
        },
        onError: (error, _, context) => {
          console.error("Error updating lead:", error);
          toast.error(error.response?.data?.msg || ERROR_MSG);
          // Rollback to previous state on error
          if (context?.previousDeal) {
        queryClient.setQueryData(["deal", dealData?._id], context?.previousDeal);
      }
        },
      });
      
      const handleStageChange = (stage) => {
        if (!dealData?.editable) {
            toast.warning(
              `You are not able to edit. Because deal is converted to ${dealData?.currentStatus?.name}`
            );
            return;
          } else if (stage?.id === currentStage?.id) {
            toast.warning("You are already on this stage!");
            return;
          }
    
        setSelectedStage(stage);
        setPendingStageChange(stage);
          if (stage?.dealWon || stage?.dealLost) {
      setShowConfirmModal(true);
    }
        
       
        // Don't automatically update stage here - wait for Update button click
      };
    
   

      const handleUpdate = () => {
        // Prepare updated call history remarks
        const updatedCallRemarks = newRemark.trim() ? [
          ...remarkHistory,
          {
            message: newRemark.trim(),
            dateTime: new Date().toISOString(),
            userIdentity: {
              id: user?.id || user?._id,
              name: user?.name || user?.firstName + ' ' + user?.lastName,
              email: user?.email
            }
          }
        ] : remarkHistory;

       

        // If there's a pending stage change, update stage along with remarks
        if (pendingStageChange) {
          mutationUpdate.mutate({ 
            id: dealData?._id, 
            updatedStage: pendingStageChange,
            callHistoryRemarks: updatedCallRemarks
          });
        } else {
            // If no stage change, just update remarks
            mutationUpdate.mutate({ 
                id: dealData?._id, 
                callHistoryRemarks: updatedCallRemarks
            });

        
        }
        closeModal();
      };

      const addRemarkToList = () => {
        if (newRemark.trim()) {
          const newRemarkObj = {
            message: newRemark.trim(),
            dateTime: new Date().toISOString(),
            userIdentity: {
              id: user?.id || user?._id,
              name: user?.name || user?.firstName + ' ' + user?.lastName,
              email: user?.email
            }
          };
          setRemarkHistory([newRemarkObj,...remarkHistory]);
          setNewRemark('');
        }
      };

        const handleConfirm = () => {
  
    setShowConfirmModal(false);
  };
  const handleDismiss = () => {
    // Reset pending stage change and selected stage
    setPendingStageChange(null);
    setSelectedStage({});
    setShowConfirmModal(false);
  }

      useEffect(() => {
        // Reset state when modal opens
        if (isOpen) {
          setRemarkHistory(dealData?.callHistoryRemarks || []);
          setNewRemark('');
          setPendingStageChange(null);
          setSelectedStage({});
        }
      }, [isOpen, dealData]);

  return (
    <div>
         {/* <SetReminderModal data={dealData} module="lead" /> */}
     
               
      {/* Modal */}
    {isOpen && (
  <>
    {/* Custom Modal Backdrop */}
    <div
      className="custom-modal-backdrop"
   
    ></div>

    {/* Custom Modal Wrapper */}
    <div
      className="custom-modal-wrapper"
      role="dialog"
    >
      <div
        className="custom-modal-container"
      >
        <div className="custom-modal-content">
          {/* Modal Header */}
          <div className="custom-modal-header d-flex justify-content-between align-items-center p-3 border-bottom">
            <h5 className="modal-title m-0">Quick Update & Remark</h5>
           
          </div>

          {/* Modal Body */}
          <div className="custom-modal-body p-0" style={{ flex: 1, overflow: 'auto' }}>
            <div className="card p-2 m-0">
              {/* Lead Pipeline Status */}
              <div className="card-body p-2 mt-2">
                <h5 className="fw-semibold mb-3">Lead Pipeline Status</h5>
                <div className="d-flex flex-wrap pipeline-list">
                  {isLoading || mutationUpdate?.isPending
                    ? Array(7).fill(null).map((_, index) => (
                      <div key={index} className="d-flex align-items-center stage-container position-relative">
                        <div
                          className="px-2 py-1 rounded-pill text-white d-flex align-items-center mb-3 text-capitalize"
                          style={{
                            width: "5rem",
                            height: "2rem",
                            backgroundColor: "lightgray",
                            cursor: "default",
                            transition: "all 0.2s ease-in-out",
                          }}
                        ></div>
                        {index < 6 && (
                          <div className="d-flex align-items-center h-100 position-relative" style={{ transform: "translateY(-6px)" }}>
                            <HiOutlineArrowNarrowRight size={25} className="stage-arrow" color="lightgray" />
                          </div>
                        )}
                      </div>
                    ))
                    : stages?.map((stage, index) => (
                      <div key={stage?.id} className="d-flex align-items-center stage-container position-relative">
                        <div
                          className={`px-2 py-1 rounded-pill text-white d-flex align-items-center mb-3 text-capitalize ${
                            stage?.id === (pendingStageChange?.id || currentStage?.id) ? "shadow-lg active-stage" : "inactive-stage"
                          }`}
                          style={{
                            backgroundColor: stage?.color,
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                            ...(pendingStageChange?.id === stage?.id && stage?.id !== currentStage?.id
                              ? {
                                  border: '2px solid #ffc107',
                                  boxShadow: '0 0 10px rgba(255, 193, 7, 0.5)',
                                }
                              : {}),
                          }}
                          onClick={() => handleStageChange(stage)}
                        >
                          <span className="stage-name">{stage?.name}</span>
                        </div>
                        {index < stages?.length - 1 && (
                          <div className="d-flex align-items-center h-100 position-relative" style={{ transform: "translateY(-6px)" }}>
                            <HiOutlineArrowNarrowRight size={25} className="stage-arrow" />
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>

              <div className="card-body d-flex flex-row p-0 m-0 flex-wrap-reverse">
                <div className="col-md-8">
                  <DealDetailsSidebar dealData={dealData} />
                </div>

                 {/* Call History Remarks Section */}
                <div className="card col-md-4">
                  <div className="card-body" style={{ height: "100%" }}>
                    <div className="mb-3">
                      <h6 className="mb-3">Add New Call Remark</h6>
                 <div className="d-flex flex-column gap-2">
  
  <div className="d-flex align-items-start gap-2">
    {/* Textarea */}
    <textarea
      className="form-control flex-grow-1"
      value={newRemark}
      onChange={(e) => setNewRemark(e.target.value)}
      rows="3"
      placeholder="Enter your call remark here..."
      style={{ resize: "none" }}
    ></textarea>

    {/* Circular Button */}
    <button
      type="button"
      className="btn btn-primary text-white rounded d-flex align-items-center justify-content-center"
      onClick={addRemarkToList}
      disabled={!newRemark.trim()}
    >
     Add
    </button>
  </div>
</div>

                    </div>
                    <div>
                      <h6>
                        <small className="badge rounded-pill text-bg-primary text-white">
                          {remarkHistory?.length}
                        </small>{" "}
                        Call History Remarks
                      </h6>
                      <div className="remarks-container mt-3" style={{ overflowY: "auto" }}>
                        {remarkHistory?.length > 0 ? (
                          remarkHistory.map((remark, index) => (
                            <div key={index} className="card mb-2 border border-dark" style={{ borderLeft: "3px solid #007bff" }}>
                              <div className="card-body p-2">
                                <p className="mb-1 text-black text-capitalize">
                                  {typeof remark === "string" ? remark : remark.message}
                                </p>
                                {typeof remark === "object" && remark.dateTime && (
                                  <div className="d-flex justify-content-between align-items-center">
                                    <small className="text-muted">
                                      <i className="fas fa-user me-1 text-capitalize"></i>
                                      {remark.userIdentity?.name || "Unknown User"}
                                    </small>
                                    <small className="text-muted">
                                      <i className="fas fa-clock me-1"></i>
                                      {formatDateTime(remark.dateTime)}
                                    </small>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                        ) : (
                          <p className="text-muted">No remarks added yet.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="custom-modal-footer d-flex justify-content-end p-3 border-top">
          
            <button type="button" className="btn btn-primary" onClick={handleUpdate}>
              {mutationUpdate.isPending ? 'Updating...' : 'Update Changes'}
            </button>
          </div>
        </div>
      </div>
    </div>

    <DealConfirmModal
      open={showConfirmModal}
      onClose={handleDismiss}
      onConfirm={handleConfirm}
      selectedStage={selectedStage}
      dealData={dealData}
    />
  </>
)}

    </div>
  )
}